import React from "react";
import moment from "moment";

function CandidateDetialBox({ props, startDate, EndDate, editCandidatProfile }) {
  const datenow = moment().format("YYYY-MM-DD");
  const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
  let date = new Date(datenow);

  let start = new Date(props.candidatStartDate);
  let end = new Date(props.candidatEndDate);

  return (
    <>
      <div className="tw-flex tw-flex-col tw-space-y-2 tw-bg-white tw-shadow-lg tw-rounded-xl force-overflow tw-my-4 tw-p-6">
        <div className="tw-flex tw-items-center tw-space-x-2">
          <p className="tw-font-semibold tw-underline">Languages: </p>
          <span className="tw-font-semibold tw-text-xl tw-text-black">
            {props.candidatLanguages.length
              ? props.candidatLanguages.join(", ")
              : "✘✘No Language!"}
          </span>
          {
            LoginUser?.username === 'PJ Darche' ? null :
              <span className="tw-cursor-pointer" onClick={editCandidatProfile}>
                <img style={{ filter: "invert(1)", height: "20px" }} alt="..." src={require("../../images/Edit.svg").default} />
              </span>
          }
        </div>
        <div className="tw-flex tw-items-center tw-space-x-2">
          <p className="tw-font-semibold tw-underline tw-text-blue-500">Ready for work: </p>
          <span
            className="tw-font-semibold tw-text-xl tw-text-black"
            style={{
              color: "#3F76E2",
            }}
          >
            {props.candidatStartDate
              ? props.candidatStartDate
              : "✘✘No Dates! "}
          </span>
          {LoginUser?.username === 'PJ Darche' ? null : <span className="tw-cursor-pointer" onClick={editCandidatProfile}>
            <img style={{ filter: "invert(1)", height: "20px" }} alt="..." src={require("../../images/Edit.svg").default} />
          </span>}
        </div>
        <div className="tw-flex tw-items-center tw-space-x-2">
          <p className="tw-font-semibold tw-underline">Candidate Owner: </p>
          <span className="tw-font-semibold tw-text-xl tw-text-black tw-capitalize">
            {props?.enteredBy ? props?.enteredBy : "✘✘No Name!"}
          </span>
          {LoginUser?.username === 'PJ Darche' ? null : <span className="tw-cursor-pointer" onClick={editCandidatProfile}>
            <img style={{ filter: "invert(1)", height: "20px" }} alt="..." src={require("../../images/Edit.svg").default} />
          </span>}
        </div>

        <div className="tw-flex tw-items-center tw-space-x-2">
          <p className="tw-font-semibold tw-underline">Driver License </p>
          <span className="tw-font-semibold tw-text-xl tw-text-black tw-capitalize">
            : {props.candidatLicensePermis ? `✔ Yes` : "✘ No"}
          </span>
          {LoginUser?.username === 'PJ Darche' ? null : <span className="tw-cursor-pointer" onClick={editCandidatProfile}>
            <img style={{ filter: "invert(1)", height: "20px" }} alt="..." src={require("../../images/Edit.svg").default} />
          </span>}
        </div>

        <div className="tw-flex tw-items-center tw-space-x-2">
          <p className="tw-font-semibold tw-underline">Candidate Address: </p>
          <span className="tw-font-semibold tw-text-xl tw-text-black tw-capitalize">
            {props?.candidatAddress ? props?.candidatAddress : "✘No Address!"}
          </span>
          {LoginUser?.username === 'PJ Darche' ? null : <span className="tw-cursor-pointer" onClick={editCandidatProfile}>
            <img style={{ filter: "invert(1)", height: "20px" }} alt="..." src={require("../../images/Edit.svg").default} />
          </span>}
        </div>

        <div className="tw-flex tw-flex-1 tw-items-top tw-space-x-8">
          <div className="tw-flex tw-space-x-2 ">
            <p className="tw-font-semibold tw-underline">
              Skills/Notes:
            </p>
            {LoginUser?.username === 'PJ Darche' ? null : <img className="tw-cursor-pointer" onClick={editCandidatProfile} style={{ filter: "invert(1)", height: "22px" }} alt="..." src={require("../../images/Edit.svg").default} />}
          </div>

          <span className="tw-font-semibold tw-text-xl tw-text-black tw-capitalize">
            {props.candidatSkills && !props.candidatSkills?.includes("[") ? props.candidatSkills : props.candidatSkills?.includes("[") ? JSON.parse(props.candidatSkills)?.map((el: any) =>
              <span className="tw-flex" >
                (Date : {el.date}) - {"  "}
                <span dangerouslySetInnerHTML={{ __html: el.value }} />
              </span>) : "✘No Skills!"}
          </span>
        </div>
      </div>
    </>
  );
}
export default CandidateDetialBox;
